import { isMobile } from './common'

let menuOpener = null
let closeTimer = null
const focusableSelector = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

export function handleToggleMobileTopMenu() {
  $('.mobile-menu-toggler').click(function() {
    const menuOpened = $('body').hasClass('mobile-top-menu-opened')

    if (menuOpened) {
      closeSideNavMenu(true)
    } else {
      openSideNavMenu(this)
    }
  })

  $(document).on('keydown', function(event) {
    const menuOpened = $('body').hasClass('mobile-top-menu-opened')

    if (event.key === 'Escape' && menuOpened) {
      closeSideNavMenu(true)
    } else if (event.key === 'Tab' && menuOpened) {
      containSideNavFocus(event)
    }
  })

  $(window).resize(function() {
    const menuOpened = $('body').hasClass('mobile-top-menu-opened')
    if (!isMobile() && menuOpened) {
      closeSideNavMenu(false)
    }
  })
}

export function handleToggleShowSubMenu() {
  $('.nav-menu').find('.submenu-toggle').click(function() {
    const $navItem = $(this).closest('.nav-item')
    const activeIndex = $('.nav-menu').find('.nav-item.active').data('index')
    const index = $navItem.data('index')

    $navItem.removeClass('active')
    $('.nav-menu').find('.submenu-toggle').attr('aria-expanded', 'false')

    if (index !== activeIndex) {
      $('.nav-menu').find('.nav-item').removeClass('active')
      $navItem.addClass('active')
      $(this).attr('aria-expanded', 'true')
    }
  })
}

function getSideNavFocusableItems($menu) {
  return $menu.find(focusableSelector).filter(':visible')
}

function containSideNavFocus(event) {
  const $menu = $('.primary-mobile-menu')
  const menu = $menu.get(0)

  if (!menu) {
    return
  }

  const focusableItems = getSideNavFocusableItems($menu).toArray()
  const firstFocusable = focusableItems[0] || menu
  const lastFocusable = focusableItems[focusableItems.length - 1] || menu
  const activeElement = document.activeElement

  if (!menu.contains(activeElement)) {
    event.preventDefault()
    menu.focus()
    return
  }

  if (event.shiftKey && (activeElement === menu || activeElement === firstFocusable)) {
    event.preventDefault()
    lastFocusable.focus()
    return
  }

  if (!event.shiftKey && activeElement === lastFocusable) {
    event.preventDefault()
    firstFocusable.focus()
  }
}


function closeSideNavMenu(restoreFocus = false) {
  const $menu = $('.primary-mobile-menu')

  if (!$menu.hasClass('opened')) {
    return
  }

  clearTimeout(closeTimer)
  $('.wrap, footer').show().animate({ transform: 'translateX(0)' }, 500)
  $('body').removeClass('mobile-top-menu-opened')
  $('.mobile-menu-toggler[aria-controls="primary-mobile-menu"]').attr('aria-expanded', 'false')
  $menu.attr('aria-hidden', 'true').removeClass('opened').addClass('is-closing')

  let closeFinished = false
  const finishClose = () => {
    if (closeFinished) {
      return
    }

    closeFinished = true
    clearTimeout(closeTimer)
    $menu.attr('hidden', true).removeClass('is-closing')

    if (restoreFocus && menuOpener) {
      menuOpener.focus()
    }
  }

  $menu.one('transitionend', function(event) {
    if (event.originalEvent.propertyName === 'transform') {
      finishClose()
    }
  })

  closeTimer = setTimeout(finishClose, 600)
}

function openSideNavMenu(opener) {
  const $menu = $('.primary-mobile-menu')

  clearTimeout(closeTimer)
  menuOpener = opener
  $('body').addClass('mobile-top-menu-opened')
  $('.mobile-menu-toggler[aria-controls="primary-mobile-menu"]').attr('aria-expanded', 'true')
  $menu.removeAttr('hidden').attr('aria-hidden', 'false').removeClass('is-closing')

  window.requestAnimationFrame(() => {
    $menu.addClass('opened')
    $menu.trigger('focus')
  })

  $('.wrap, footer').show().animate({ transform: 'translateX(0)' }, 500)
  $('body').removeClass('mobile-top-header-opened')
  $('.top-header-mobile').removeClass('opened')
}



// WEBPACK FOOTER //
// ./scripts/func/menu.js